<script>
/* eslint-disable vue/no-mutating-props */
import { getDate, getShortMonth, getYear } from '~/modules/helpers/day'

export default {
  props: {
    news: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      keys: ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l']
    }
  },
  methods: { getDate, getShortMonth, getYear }
}
</script>

<template>
  <div class="w-full collage">
    <div
      v-for="(item, index) in news.splice(0, 12)"
      :key="item._id"
      class="overflow-hidden rounded-lg bg-cover bg-black relative"
      :style="`grid-area: ${keys[index]};`"
    >
      <nuxt-link :to="`/news/${item._id}`">
        <img
          loading="lazy"
          :src="`https://ucarecdn.com/${item.img.fileKey}/-/format/auto/-/quality/smart/image.png`"
          class="w-full h-full object-cover transform-gpu transition-all duration-300 opacity-80 hover:opacity-60"
        />
        <template
          v-if="index === 0 || index === 5 || index === 8 || index === 11"
        >
          <div
            class="absolute bottom-0 left-0 right-0 hidden xl:grid grid-cols-12 z-10 h-32"
          >
            <div class="relative w-40 col-start-1 col-end-3">
              <div
                class="absolute rounded-4xl bg-ternary -z-1 transform-gpu rotate-26"
                style="width: 194px; height: 180px; left: -60px"
              />
              <div
                class="absolute z-10 top-0 bottom-0 right-2 left-0 pr-2 flex flex-col justify-center"
              >
                <div
                  class="mx-auto font-sans font-medium text-4xl uppercase text-white"
                >
                  {{ getDate(item.createdAt) }}
                </div>
                <div class="mx-auto">
                  <img
                    loading="lazy"
                    src="/line.svg"
                    style="height: 2px"
                  />
                </div>
                <div class="mx-auto font-sans font-medium text-xl text-white">
                  {{ getShortMonth(item.createdAt) }}
                </div>
              </div>
            </div>
            <div class="relative p-4 flex w-auto col-start-4 col-end-12">
              <p
                class="cards__news__text text-white mt-auto text-lg2"
                v-html="item.name"
              ></p>
            </div>
          </div>
          <div
            class="absolute bottom-0 left-0 right-0 z-10 flex xl:hidden flex-col space-y-1 p-4"
          >
            <h6 class="text-white font-sans text-lg">
              {{ getDate(item.createdAt) }}
              {{ getShortMonth(item.createdAt) }}
              {{ getYear(item.createdAt) }}
            </h6>
            <div class="relative flex w-full col-start-4 col-end-12">
              <h2
                class="cards__news__text text-white mt-auto text-lg2"
                v-html="item.name"
              ></h2>
            </div>
          </div>
        </template>
        <div
          v-else
          class="absolute bottom-0 left-0 right-0 z-10 flex flex-col space-y-1 p-4"
        >
          <div class="text-white font-sans text-lg">
            {{ getDate(item.createdAt) }}
            {{ getShortMonth(item.createdAt) }}
            {{ getYear(item.createdAt) }}
          </div>
          <div class="relative flex w-full col-start-4 col-end-12">
            <h2
              class="cards__news__text text-white mt-auto text-lg2"
              v-html="item.name"
            ></h2>
          </div>
        </div>
      </nuxt-link>
    </div>
  </div>
</template>

<style scoped>
.collage {
  display: grid;
  gap: 1.75rem;
  grid-template-columns: repeat(1, minmax(0, 1fr));
  grid-template-rows: repeat(12, minmax(0, 204px));
  grid-template-areas:
    'a'
    'b'
    'c'
    'd'
    'e'
    'f'
    'g'
    'h'
    'i'
    'j'
    'k'
    'l';
}

@media screen and (min-width: 768px) {
  .collage {
    grid-template-rows: repeat(12, minmax(0, 400px));
  }
}

@media screen and (min-width: 1280px) {
  .collage {
    grid-template-columns: repeat(4, minmax(0, 1fr));
    grid-template-rows: 334px 40px 334px 334px 40px 334px;
    grid-template-areas:
      'a a b c'
      'd e b c'
      'd e f f'
      'g h i i'
      'g h j k'
      'l l j k';
  }
}

img.object-cover {
  position: absolute;
  left: 0%;
  top: 0%;
  width: 100%;
  height: 100%;
  min-width: 100%;
  min-height: 100%;
  transition: 0.3s;
  max-width: 100vw;
}
img.object-cover:hover {
  position: absolute;
  width: 110%;
  height: 110%;
  min-width: 110%;
  min-height: 110%;
  left: -5%;
  top: -5%;
}
</style>
